"use client";

import { FunctionComponent, PropsWithChildren } from "react";
import { ApolloProvider, InMemoryCache } from "@apollo/client";
import { useAppApolloClient } from "../hooks/apollo-client";
import { KeyValueObject } from "../types/general";

export interface GraphQLProviderProps {
    cache: InMemoryCache;
    lang: string;
    uri: string;
    headers?: KeyValueObject;
}

export const GraphQLProvider: FunctionComponent<PropsWithChildren<GraphQLProviderProps>> = ({ cache, lang, uri, headers, children }) => {
    const client = useAppApolloClient(cache, lang, uri, headers);

    return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
